export default "__VITE_ASSET__BE5Nptl9__";